import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";

function MobileMenuContainer() {
  const [navVisible, setNavVisible] = useState(false);
   const [bookSubmenuVisible, setBookSubmenuVisible] = useState(false);
  const [pagesSubmenuVisible, setPagesSubmenuVisible] = useState(false);

  const toggleNav = () => {
    setNavVisible(!navVisible);
  };

 
  const toggleBookSubmenu = () => {
    setBookSubmenuVisible(!bookSubmenuVisible);
  };

  const togglePagesSubmenu = () => {
    setPagesSubmenuVisible(!pagesSubmenuVisible);
  };

  return (
    <>
      <div className="mobile-menu-container">
        <div className="slicknav_menu">
          <a
            href="#"
            aria-haspopup="true"
            tabIndex="0"
            className={`slicknav_btn ${navVisible ? "" : "slicknav_collapsed"}`}
            onClick={toggleNav}
          >
            <span className="slicknav_menutxt">Menu</span>
            <span className="slicknav_icon">
              <span className="slicknav_icon-bar"></span>
              <span className="slicknav_icon-bar"></span>
              <span className="slicknav_icon-bar"></span>
            </span>
          </a>
          <nav
            className={`slicknav_nav ${navVisible ? "" : "slicknav_hidden"}`}
            aria-hidden={!navVisible}
            role="menu"
            style={{ display: navVisible ? "block" : "none" }}
          >
            <ul>
              <li className="menu-item-has-children slicknav_collapsed slicknav_parent">
                <span className="slicknav_parent-link slicknav_row">
                  <Link to="/">Home</Link>
                </span>
              </li>
              <li className="menu-item-has-children slicknav_collapsed slicknav_parent">
                <span className="slicknav_parent-link slicknav_row">
                <Link to="/TourPackages" role="menuitem" tabIndex="-1">
                      Tour Packages
                    </Link>
                  
                </span>
                
              </li>

              <li className="menu-item-has-children slicknav_collapsed slicknav_parent">
                <span className="slicknav_parent-link slicknav_row">
                  <a href="#">Province Packages</a>
                  <a
                    href="#"
                    role="menuitem"
                    aria-haspopup="true"
                    tabIndex="-1"
                    className="slicknav_item"
                    onClick={toggleBookSubmenu}
                  >
                    <span className="slicknav_arrow">
                      <i
                        className={`fas ${
                          bookSubmenuVisible ? "fa-minus" : "fa-plus"
                        }`}
                      ></i>
                    </span>
                  </a>
                </span>
                <ul
                  role="menu"
                  className={`slicknav_hidden ${
                    bookSubmenuVisible ? "" : "slicknav_hidden"
                  }`}
                  style={{ display: bookSubmenuVisible ? "block" : "none" }}
                  aria-hidden={!bookSubmenuVisible}
                >
                 
                      <li>
                        <Link to="/Punjab">Punjab</Link>
                      </li>
                      <li>
                        <Link to="/Sindh">Sindh</Link>
                      </li>
                      <li>
                       <Link to="/Balochistan">Balochistan</Link>
                      </li>
                      <li>
                        <Link to="/KPK">KPK</Link>
                      </li>
                    <li>
                       <Link to="/GilgitBaltistan">Gilgit Baltistan</Link>
                      </li>
                      <li>
                       <Link to="/AzadKashmir">Azad Kashmir</Link>
                      </li>
                </ul>
              </li>

              <li className="menu-item-has-children slicknav_collapsed slicknav_parent">
                <span className="slicknav_parent-link slicknav_row">
                  <a href="#">Pages</a>
                  <a
                    href="#"
                    role="menuitem"
                    aria-haspopup="true"
                    tabIndex="-1"
                    className="slicknav_item"
                    onClick={togglePagesSubmenu}
                  >
                    <span className="slicknav_arrow">
                      <i
                        className={`fas ${
                          pagesSubmenuVisible ? "fa-minus" : "fa-plus"
                        }`}
                      ></i>
                    </span>
                  </a>
                </span>
                <ul
                  role="menu"
                  className={`slicknav_hidden ${
                    pagesSubmenuVisible ? "" : "slicknav_hidden"
                  }`}
                  style={{ display: pagesSubmenuVisible ? "block" : "none" }}
                  aria-hidden={!pagesSubmenuVisible}
                >
                  <li>
                    <Link to="/About" role="menuitem" tabIndex="-1">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/Contact" role="menuitem" tabIndex="-1">
                      Contact
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default MobileMenuContainer;
